export default __webpack_public_path__ + "static/media/euro-IconGreen.d5a3d9dd.svg";